<template>
  <v-card class="pa-8 ma-10" color="gray9">
    <div class="d-flex align-center">
      <v-icon clr="var(--v-primary-base)">$faqMail</v-icon>
      <span class="font-Regular-14 ms-2" v-html="htmlContent.page_title" />
    </div>
    <v-divider class="my-4"></v-divider>
    <div v-html="htmlContent.page_content" />
  </v-card>
</template>

<script>
import legalService from "@/services/modules/legalService";

export default {
  name: "LegalEntityRules",
  data() {
    return {
      htmlContent: ""
    };
  },
  mounted() {
    legalService.getUserTerms().then(res => {
      this.htmlContent = res.data.data;
    });
  }
};
</script>

<style lang="scss" scoped></style>
